import React, { useState, useEffect } from 'react'
import AddAvailability from '../../../components/vendor-login/ordersComponent/vehicleAvailability/addAvailability.js';
const AddVehicleToVehicleAvailability = ({
    t,
    ...props
}) => {

    useEffect(() => {
    }, [])

    return (
        <>
            <AddAvailability onlyAddVehicle={false} fromAdmin={true}>
            </AddAvailability>
        </>
    );
};

export default AddVehicleToVehicleAvailability;